import { render } from "./StockModal.vue?vue&type=template&id=4d318420"
import script from "./StockModal.vue?vue&type=script&lang=js"
export * from "./StockModal.vue?vue&type=script&lang=js"

import "./StockModal.vue?vue&type=style&index=0&id=4d318420&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__